// @flow

import * as React from "react";

type PropsType = {
    label?: string,
    children: React.Node,
    required?: boolean,
};

const CheckboxGroup = (props: PropsType): React.Node => {
    return (
        <fieldset className="checkbox-group">
            {props.label ? (
                <legend className="checkbox-group__label">
                    {props.label}
                    {props.required ? null : (
                        <span
                            className={`react-form__field__label__optional-label`}
                        >
                            {" "}
                            (optional)
                        </span>
                    )}
                </legend>
            ) : null}
            <div className="checkbox-group__contents">{props.children}</div>
        </fieldset>
    );
};

export default CheckboxGroup;
